// extracted by mini-css-extract-plugin
export var label = "_ha-2";
export var slideContainer = "_ha-0";
export var slider = "_ha-1";